<template>
  <div class='login-all'>
    <div class="header">
      <div class="zhl-flex-c">
        <img class="icon-logo"
             src="@/assets/images/login/icon-logo.png">
      </div>
      <div class="zhl-flex-c">云教英语听说专练系统</div>
    </div>
    <div class="content">
      <div class="nav zhl-flex-sc">
        <div :class="['nav-item zhl-flex-c', selectNav.id === item.id ? 'active' : '']"
             v-for="item in navList"
             :key="item.id"
             @click="handleNav(item)">
          <div>{{ item.text }}</div>
          <div v-show="selectNav.id === item.id"
               class="line"></div>
        </div>
      </div>
      <div class="input-item">
        <van-field v-model="formData.phone"
                   type="tel"
                   maxlength="11"
                   placeholder="请输入手机号码">
          <template #button>
            <img v-show="formData.phone"
                 class="icon-close"
                 src="@/assets/images/login/icon-close.png"
                 @click="formData.phone = ''">
          </template>
        </van-field>
      </div>
      <input type="text"
             value=""
             style=" opacity: 0; width: 0;height: 0; padding: 0;outline: none;" />
      <div v-show="selectNav.id === 1"
           class="input-item top">
        <van-field v-model="formData.password"
                   type="password"
                   maxlength="16"
                   placeholder="请输入密码">
          <template #button>
            <img v-show="formData.password"
                 class="icon-close"
                 src="@/assets/images/login/icon-close.png"
                 @click="formData.password = ''">
          </template>
        </van-field>
      </div>
      <div v-show="selectNav.id === 2"
           class="input-item top">
        <van-field v-model="formData.code"
                   type="tel"
                   maxlength="4"
                   placeholder="请输入验证码">
          <template #button>
            <div class="zhl-flex-vc">
              <img v-show="formData.code"
                   class="icon-close"
                   src="@/assets/images/login/icon-close.png"
                   @click="formData.code = ''">
              <span v-if="!contDown"
                    @click="getApplyRegist"
                    :class="['code-btn', checkPhone ? 'active' : '']">获取验证码</span>
              <div class="code-btn zhl-flex"
                   v-else>重新获取(
                <van-count-down @finish="contDown = false"
                                format="ss"
                                :time="countDownTime" />
                s)
              </div>
            </div>
          </template>
        </van-field>
      </div>
      <div class="zhl-flex-vc agreement-wrapper">
        <van-popover v-model="showPopover"
                     placement="top-start"
                     theme="dark"
                     :actions="actions"
                     trigger="click"
                     get-container="#login">
        </van-popover>
        <img ref="Agreement"
             v-show="!isAgreement"
             class="icon-select"
             src="@/assets/images/login/icon-un-select.png"
             @click="handleBtn(7)">
        <img v-show="isAgreement"
             class="icon-select"
             src="@/assets/images/login/icon-select.png"
             @click="handleBtn(7)">
        <span>已阅读并同意</span>
        <span class="agreement"
              @click="handleBtn(1)">《用户协议》</span>
        <span>和</span>
        <span class="agreement"
              @click="handleBtn(2)">《隐私政策》</span>
      </div>
      <div :class="['btn zhl-flex-c', loginBtn ? 'active' : '']"
           @click="checkMsgCode">登录</div>
      <div class="zhl-flex-sc register-wrapper">
        <div class="zhl-flex-vc">
          <span>还没有账号？去</span>
          <span class="register"
                @click="handleBtn(3)">注册</span>
        </div>
        <div class="password"
             @click="handleBtn(4)">忘记密码？</div>
      </div>
    </div>
    <div class="other zhl-flex-sc">
      <div class="line"></div>
      <div>其他登录方式</div>
      <div class="line"></div>
    </div>
    <div :class="['other-login', isWeiXin ? 'zhl-flex-sc' : 'zhl-flex-c']">
      <div v-show="isWeiXin"
           class="cursor"
           @click="handleBtn(5)">
        <div class="zhl-flex-c">
          <img class="other-img"
               src="@/assets/images/login/icon-weixin.png">
        </div>
        <div>微信登录</div>
      </div>
      <div class="cursor"
           @click="handleBtn(6)">
        <div class="zhl-flex-c">
          <img class="other-img"
               src="@/assets/images/login/icon-yunjiao.png">
        </div>
        <div>滇教云登录</div>
      </div>
    </div>
    <!--PC及H5-->
    <div v-html="fontSizeStyle"></div>
  </div>
</template>

<script>
import { getArgs, getTerminal, HttpFactory, setCookie, md5, getCookie, isWeiXin } from '@/assets/js/common'
import rqParams from '../rq'
export default {
  data() {
    return {
      navList: [
        {
          id: 1,
          text: '密码登录'
        },
        {
          id: 2,
          text: '验证码登录'
        }
      ], // 登录导航模块处理
      selectNav: {
        id: 1,
        text: '密码登录'
      }, // 选中的登录方式
      formData: {
        phone: '',
        password: '',
        code: ''
      }, // 表单数据
      contDown: false, // 时间
      countDownTime: 60 * 1000, // 获取验证码间隔时间
      showPopover: false, // 是否显示气泡
      isAgreement: false, // 是否勾选协议
      actions: [{ text: '请勾选同意后再登录' }],
      isWeiXin: false, // 判断是否是微信环境
      config: {
        scope: 'snsapi_userinfo',
        client_id: 'yjyy-listen-speak',
        client_secret: 'X5mbzTBEq5j5LVWbiDE3xhE9pLqvjovy'
      }, // 微信授权配置
      vanPopoverDark: 0 // 协议同意框的位置
    }
  },
  created() {
    const params = getArgs()
    if (params.code) {
      // 根据code获取open_id
      this.getTokenByWeChatCode(params.code)
    }
    this.formData.phone = localStorage.getItem('phone') ? localStorage.getItem('phone') : ''
    this.isWeiXin = isWeiXin()
    window.addEventListener('popstate', () => {
      history.pushState(null, null, document.URL)
    }, false)
    if (getCookie('token')) {
      if (params.goFrom) {
        location.replace(params.goFrom)
      } else {
        location.replace('./EnglishHome.html')
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getPositionElement('Agreement')
    })
  },
  computed: {
    /**
     * 手机号正误的检测
     */
    checkPhone() {
      if (/^1\d{10}$/.test(this.formData.phone)) {
        return true
      } else {
        return false
      }
    },
    /**
     * 按钮是否可用
     */
    loginBtn() {
      if (this.selectNav.id === 2) {
        return /^1\d{10}$/.test(this.formData.phone) && this.formData.code.length === 4
      } else {
        return /^1\d{10}$/.test(this.formData.phone) && this.formData.password.length >= 6
      }
    },
    /**
     * 协议同意框在PC与H5的距离
     */
    fontSizeStyle() {
      if (getTerminal() === 'ios' || getTerminal() === 'android') {
        return `<style>.van-popover--dark {left: 32px !important;}</style>`
      } else {
        return `<style>.van-popover--dark {left: ${this.vanPopoverDark}px !important;}</style>`
      }
    }
  },
  watch: {
    /**
     * 监听密码
     */
    'formData.password'(val) {
      if (!/^[A-Za-z0-9]+$/.test(val)) {
        this.formData.password = val.substring(0, val.length - 1)
      }
    }
  },
  methods: {
    /**
     * 点击导航项
     */
    handleNav(item) {
      this.selectNav = item
    },
    /**
     * 获取某个元素的位置
     */
    getPositionElement(element) {
      const { left } = this.$refs[element].getBoundingClientRect()
      this.vanPopoverDark = parseInt(left) - 8
    },
    /**
     * 点击跳转项
     */
    handleBtn(index) {
      if (index === 1) {
        // 用户协议
        location.href = `./UserAgreement.html?id=${process.env.VUE_APP_USER_AGREEMENT}`
      } else if (index === 2) {
        // 隐私政策
        location.href = `./PrivacyAgreement.html?id=${process.env.VUE_APP_PRIVACY_AGREEMENT}`
      } else if (index === 3) {
        // 注册
        location.href = './RegisterAccount.html'
      } else if (index === 4) {
        // 忘记密码
        location.href = './ForgetPassword.html'
      } else if (index === 5) {
        // 微信登录
        this.wxAuthorizeLogin()
      } else if (index === 6) {
        // 云南教育云登录
        location.replace('https://djysso.yneducloud.com/login?CLIENTIDENT=djy-yingyutingshuo&REDIRECTURI=https://yjts.yneducloud.com/EnglishHome.html')
      } else if (index === 7) {
        // 勾选
        this.isAgreement = !this.isAgreement
        if (!this.isAgreement) {
          this.showPopover = true
        } else {
          this.showPopover = false
        }
      }
    },
    /**
     * 微信授权登录
     */
    wxAuthorizeLogin() {
      if (localStorage.getItem('open_id')) {
        this.ifHasBindWeiXinOpenId()
      } else {
        // 调微信接口去授权
        const href = location.origin + location.pathname
        location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.VUE_APP_APP_ID}&redirect_uri=${encodeURIComponent(href)}&response_type=code&scope=${this.config.scope}&state=${new Date().getTime()}#wechat_redirect`
      }
    },
    /**
     * 获取微信唯一标识open_id
     */
    getTokenByWeChatCode(code) {
      const that = this
      HttpFactory.postNotokenPay(rqParams.getTokenByWeChatCode({
        app_id: process.env.VUE_APP_ZHL_APP_ID,
        code: code,
        client_id: this.config.client_id
      }), res => {
        console.log('获取微信唯一标识open_id')
        console.log(res)
        localStorage.setItem('open_id', res.data.open_id)
        localStorage.setItem('head_image_url', res.data.head_image_url)
        localStorage.setItem('nick_name', res.data.nick_name)
        that.ifHasBindWeiXinOpenId()
      })
    },
    /**
     * 根据open_id获取token
     */
    ifHasBindWeiXinOpenId() {
      HttpFactory.postNotokenPay(rqParams.ifHasBindWeiXinOpenId({
        app_id: process.env.VUE_APP_ZHL_APP_ID,
        client_id: this.config.client_id,
        open_id: localStorage.getItem('open_id')
      }), res => {
        console.log('判断微信是否绑定手机号')
        console.log(res)
        if (res.data.token) {
          setCookie('token', res.data.token)
          // 直接登录
          const params = getArgs()
          if (params.goFrom) {
            location.replace(params.goFrom)
          } else {
            location.replace('./EnglishHome.html')
          }
        } else {
          // 去微信绑定页面
          console.log('去微信绑定页面')
          location.replace('./BingWX.html')
        }
      })
    },
    /**
     * 验证电话号码
     */
    phoneChange() {
      if (this.formData.phone === '') {
        return false
      }
      if (!/^1\d{10}$/.test(this.formData.phone)) {
        return false
      }

      return true
    },
    /**
     * 获取短信验证码
     */
    getApplyRegist() {
      if (!this.phoneChange()) {
        return false
      }
      HttpFactory.postNotokenPay(rqParams.getApplyRegist({
        phone: this.formData.phone,
        type: 48
      }), res => {
        this.$toast('验证码已发送')
        this.contDown = true
      })
    },
    /**
     * 校验短信验证码
     *
     */
    checkMsgCode() {
      const that = this
      if (!this.loginBtn) return false
      if (!this.isAgreement) {
        this.showPopover = true
        return false
      }
      this.$toast({
        type: 'loading',
        message: '请稍后',
        duration: 0
      })
      if (that.selectNav.id === 1) {
        that.getToken()
      } else {
        HttpFactory.postNotokenPay(rqParams.checkMsgCode({
          phone: this.formData.phone,
          code: this.formData.code,
          type: 48,
          edition_id: 1,
          noJumpTo: true
        }), res => {
          that.getUserTokenBySmsCode(res.data)
        })
      }
    },
    /**
     * 账号密码登录
     */
    getToken() {
      const that = this
      const password = md5(this.formData.password)
      HttpFactory.postOauth(rqParams.getToken({
        username: this.formData.phone,
        password: password,
        grant_type: 'password',
        client_id: this.config.client_id,
        client_secret: this.config.client_secret,
        scope: getTerminal() === 'ios' ? 'com.zhl.yj.listen.iphone.web' : 'com.zhl.yj.listen.aphone.web'
      }), res => {
        setCookie('token', res.data.access_token)
        that.goLogin()
      })
    },
    /**
     * 根据短信验证码获取token
     */
    getUserTokenBySmsCode(res) {
      const that = this
      HttpFactory.postNotokenPay(rqParams.getUserTokenBySmsCode({
        uid: res.uid,
        code: res.code,
        client_id: this.config.client_id
      }), res => {
        setCookie('token', res.data.token)
        that.goLogin()
      })
    },
    /**
     * 登录成功，跳转
     */
    goLogin() {
      const that = this
      HttpFactory.postUrlPay(rqParams.loginVerify(), res => {
        this.$toast('登录成功')
        localStorage.setItem('phone', this.formData.phone)
        const params = getArgs()
        if (params.goFrom) {
          location.replace(params.goFrom)
        } else {
          location.replace('./EnglishHome.html')
        }
      }, () => {
        that.$toast('登录失败')
      })
    }
  }
}
</script>

<style lang='less' scoped>
.login-all {
  padding-bottom: 60px;

  /deep/ .van-popover__wrapper {
    height: 16px;
  }

  /deep/ .van-popover__action {
    width: auto;
    height: auto;
    padding: 5px 16px;
  }

  .header {
    padding: 44px 0 50px 0;
    font-size: 22px;
    font-weight: bold;
    color: #333333;

    &.active {
      padding: 150px 0 80px 0;
    }

    .icon-logo {
      margin-bottom: 15px;
      display: block;
      width: 66px;
      //height: 60px;
    }
  }

  .content {
    .nav {
      margin-bottom: 20px;
      padding: 0 80px;

      &-item {
        position: relative;
        width: 850px;
        height: 40px;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        cursor: pointer;

        &.active {
          font-weight: 500;
          color: #46d584;
        }

        .line {
          position: absolute;
          bottom: 0;
          width: 19px;
          height: 4px;
          background: #46d584;
          border-radius: 2px;
        }
      }
    }

    .input-item {
      margin: 0 40px 14px 40px;

      &.top {
        margin-top: -14px;
      }

      /deep/ .van-field {
        padding: 0;
        width: 295px;
        height: 48px;
        background: #f8f8f8;
        border-radius: 24px;
        font-size: 16px;

        .van-field__body {
          width: 100%;
          height: 100%;
        }

        .van-field__control {
          width: 100%;
          height: 100%;
          text-indent: 20px;
        }
      }

      .icon-close {
        margin-right: 20px;
        display: block;
        width: 12px;
        height: 12px;
        cursor: pointer;
      }

      .code-btn {
        margin-right: 15px;
        font-size: 14px;
        font-weight: 400;
        color: #cccccc;
        cursor: pointer;

        &.active {
          color: #46d584;
        }

        /deep/ .van-count-down {
          line-height: 24px;
          color: #cccccc;
        }
      }
    }

    .agreement-wrapper {
      margin: 20px 40px 14px 40px;
      font-size: 12px;
      font-weight: 400;
      color: #999999;

      .icon-select {
        margin-right: 6px;
        display: block;
        width: 16px;
        height: 16px;
        cursor: pointer;
      }

      .agreement {
        color: #46d584;
        cursor: pointer;
      }
    }

    .register-wrapper {
      margin: 0 40px 0 40px;
      font-size: 12px;
      font-weight: 400;
      color: #999999;

      .register {
        color: #46d584;
        cursor: pointer;
      }

      .password {
        cursor: pointer;
      }
    }
  }

  .other {
    margin: 70px 0 20px 0;
    padding: 0 25px;
    font-size: 13px;
    font-weight: 400;
    color: #999999;

    .line {
      width: 110px;
      border-top: 1px solid #f4f4f4;
    }
  }

  .other-login {
    padding: 0 100px;
    font-size: 12px;
    font-weight: 400;
    color: #999999;

    .other-img {
      margin-bottom: 6px;
      display: block;
      width: 50px;
      height: 50px;
    }
  }

  .btn {
    margin: 20px 40px 14px 40px;
    width: 295px;
    height: 48px;
    background: rgba(70, 213, 132, 0.5);
    border-radius: 24px;
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
    letter-spacing: 2px;
    cursor: pointer;

    &.active {
      background: rgba(70, 213, 132, 1);
    }
  }
}
</style>
